import { render, staticRenderFns } from "./dicTypeSelect.vue?vue&type=template&id=de376238&"
import script from "./dicTypeSelect.vue?vue&type=script&lang=ts&"
export * from "./dicTypeSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports